import * as React from 'react';
import {assets} from "../helpers";

export class Brands extends React.Component<any, any> {
    render() {
        const brands = [];
        for (let i = 0; i < 50; i++) brands.push(i + 1);
        
        return (
            <section className="newest-brands">
                {brands.map(i => <div key={i}><img src={assets(`brands/${i}.png`)} /></div>)}
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Brands.tsx
 **/